import initializeZendesk from './initialize-zendesk';

export default { initializeZendesk };
